import { Snippet } from '@distribute/shared/types';

import { SORT_ITEMS } from './config';

import {
  getFilteredSnippetsByType,
  getFilteredSnippetsByOwner,
  FILTER_SNIPPET_ITEMS,
} from '../../../entities/snippets';

import { getSortedSnippets } from './getSortedSnippets';

type Params = {
  snippets: Snippet[];
  filterByOwner?: string;
  filter: keyof typeof FILTER_SNIPPET_ITEMS;
  sort: keyof typeof SORT_ITEMS;
};

export const getSnippets = (params: Params) => {
  const { filterByOwner, filter, sort } = params;

  let snippets = params.snippets;

  if (filterByOwner) {
    snippets = getFilteredSnippetsByOwner(snippets, filterByOwner);
  }

  snippets = getFilteredSnippetsByType(snippets, filter);

  return getSortedSnippets(snippets, sort);
};
